import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export enum ProcessorDefinitions {
  PatientExists = 2,
  EpisodeExists = 3,
  EntityGroupExists = 4,
  BillingProviderExists = 5,
  AuthorizationNumberMatch = 6,
  DiagnosisInEpisodeDefinition = 7,
  ProcedureInEpisodeDefinition = 8,
  FeeScheduleExists = 9,
  ExportConfigExists = 10,
  HasMatchingClaim = 13,
  ClaimPatientHasEpisodes = 14,
  ClaimPatientDateOfBirthMatchesCandidateEpisode = 15,
  ClaimPatientLastNameMatchesCandidateEpisode = 16,
  ClaimPatientFirstNameMatchesCandidateEpisode = 17,
  ServiceStartDateMatchesCandidateEpisode = 18,
  ServiceThroughDateMatchesCandidateEpisode = 19,
  ClaimServicesAllHaveSamePatientEpisode = 20,
  PatientEpisodeBundleExistsInSystemManagement = 21,
  HasAdjudicationType = 22,
  ExactDuplicates = 26,
  NearDuplicates = 27,
  IsPlaceOfServiceOutpatientHospital = 28,
  ServiceProcedureExistsInBundle = 29,
  HasMatchingServicesOnControlNumber = 30,
  HasMatchingServicesOnProperties = 31,
  HasPossiblyBeenReceivedBefore = 32,
  KnownClaimFrequencyCode = 33,
  ClaimFrequencyOtherThanCorrected = 34,
  CorrectedClaimHasOriginalClaimNumber = 35,
  CorrectedClaimFoundOriginalClaimNumber = 36,
  HighDollarThreshold = 37,
  TimelyFiling = 38,
  UnitsMeetThresholdCriteria = 39
}

export interface IProcessorDefinition extends IModelBase {
  Id: number
  Name: string
  ProcessingPipelineId: number
  OrderIndex: number
  IsSystem: boolean
}

@Injectable()
export class ProcessorDefinitionODataService extends ODataService<IProcessorDefinition> {
  constructor(protected http: HttpClient, protected config: SmODataConfiguration) {
    super(http, config)
    this.typeName = 'ProcessorDefinitions'
  }
}
